import lippedmussel from '../../assets/images/lipped-mussel.png';
import immunity from '../../assets/images/immunity-1.png';
import internal from '../../assets/images/internal.png';
import menshealth from '../../assets/images/menshealth.png';
import energy from '../../assets/images/energy-1.png';
import brainandeye from '../../assets/images/brainandeye.png';

import { Link } from 'react-router-dom';

function ProductsRange(){
  return (
    <div className="home__range-container">
      <div className="home__range-box column">
        <div className="home__range-title">
          <h1 className="range__title-text">자연에서 온 건강</h1>
        </div>
        <div className="range__row">
          <div className="range__item item-gradient">
            <div className="range__item-box">
              <div className="range__item-wrapper">
                <div className="range__item-title">
                  <h1 className="range__item-text">관절 이동성 향상</h1>
                </div>
                <div className="range__item-image">
                  <img src={lippedmussel} alt="관절 이동성 향상"/>
                </div>
                <div className="range__item-button">
                  <Link to="/products/category/joint">
                    <button>더 알아보기</button>
                  </Link>
                </div>
              </div>
            </div>
          </div>
          <div className="range__item">
            <div className="range__item-box item-reverse-gradient">
              <div className="range__item-wrapper">
                <div className="range__item-title">
                  <h1 className="range__item-text">면역력 증진</h1>
                </div>
                <div className="range__item-image">
                  <img src={immunity} alt="면역력 증진"/>
                </div>
                <div className="range__item-button">
                  <Link to="/products/category/immune">
                    <button>더 알아보기</button>
                  </Link>
                </div>
              </div>
            </div>
          </div>
          <div className="range__item item-gradient">
            <div className="range__item-box">
              <div className="range__item-wrapper">
                <div className="range__item-title">
                  <h1 className="range__item-text">미용 보조</h1>
                </div>
                <div className="range__item-image">
                  <img src={internal} alt="미용 보조"/>
                </div>
                <div className="range__item-button">
                  <Link to="/products/category/cosmetics">
                    <button>더 알아보기</button>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="range__row">
          <div className="range__item">
            <div className="range__item-box item-reverse-gradient">
              <div className="range__item-wrapper">
                <div className="range__item-title">
                  <h1 className="range__item-text">남성 활력</h1>
                </div>
                <div className="range__item-image">
                  <img src={menshealth} alt="남성 활력"/>
                </div>
                <div className="range__item-button">
                  <Link to="/products/category/mens-health">
                    <button>더 알아보기</button>
                  </Link>
                </div>
              </div>
            </div>
          </div>
          <div className="range__item item-gradient">
            <div className="range__item-box">
              <div className="range__item-wrapper">
                <div className="range__item-title">
                  <h1 className="range__item-text">체력 증진</h1>
                </div>
                <div className="range__item-image">
                  <img src={energy} alt="체력 증진"/>
                </div>
                <div className="range__item-button">
                  <Link to="/products/category/energy">
                    <button>더 알아보기</button>
                  </Link>
                </div>
              </div>
            </div>
          </div>
          <div className="range__item">
            <div className="range__item-box item-reverse-gradient">
              <div className="range__item-wrapper">
                <div className="range__item-title">
                  <h1 className="range__item-text">두뇌와 눈 건강</h1>
                </div>
                <div className="range__item-image">
                  <img src={brainandeye} alt="두뇌와 눈 건강"/>
                </div>
                <div className="range__item-button">
                  <Link to="/products/category/brain-and-eyes">
                    <button>더 알아보기</button>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ProductsRange;